import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, type ButtonProps } from '@mui/material';
import { DeleteOutlineOutlined } from '@mui/icons-material';

export const DeleteButton: FC<ButtonProps> = ({ children, ...props }) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="outlined"
      color="error"
      startIcon={<DeleteOutlineOutlined />}
      {...props}
    >
      {children ?? t('remove')}
    </Button>
  );
};
